import React from 'react';

export const sectionHeaderStyle: React.CSSProperties = {
  fontSize: '12px',
  textTransform: 'uppercase',
  color: '#888',
  marginBottom: '10px',
  marginTop: '20px',
  fontWeight: 'bold',
  letterSpacing: '1px'
};

export const buttonStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '8px 12px',
  marginBottom: '8px',
  background: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '4px',
  color: '#ecf0f1',
  cursor: 'pointer',
  textAlign: 'left',
  fontSize: '13px',
  transition: 'all 0.2s'
};

export const infoCardStyle: React.CSSProperties = {
  background: 'rgba(0,0,0,0.3)',
  padding: '10px',
  borderRadius: '4px',
  marginBottom: '15px'
};

export const listContainerStyle: React.CSSProperties = {
  maxHeight: '150px',
  overflowY: 'auto',
  background: 'rgba(0,0,0,0.2)',
  padding: '8px',
  borderRadius: '4px',
  marginBottom: '15px'
};
